import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=269589d4&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=269589d4&lang=scss&scoped=true&"
import style1 from "./NotificationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269589d4",
  null
  
)

export default component.exports